import { render, staticRenderFns } from "./navbarPC.vue?vue&type=template&id=36ff269c&scoped=true"
import script from "./navbarPC.vue?vue&type=script&lang=js"
export * from "./navbarPC.vue?vue&type=script&lang=js"
import style0 from "./navbarPC.vue?vue&type=style&index=0&id=36ff269c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff269c",
  null
  
)

export default component.exports